/* eslint-disable react/prefer-stateless-function */
// TODO make System500 a pure function
import React from 'react'
import { Helmet } from 'react-helmet'
import { Result } from 'antd'

import 'antd/lib/result/style'

export class System500 extends React.Component {
  render() {
    return (
      <Result status="500" title="500" subTitle="Sorry, the server is wrong.">
        <Helmet title="Oops.." />
      </Result>
    )
  }
}

export default {
  name: '500',
  routeProps: {
    path: '/500',
    component: System500,
  },
}
